module.exports = __webpack_public_path__ + "img/bikkurapon_icon_tw.ca178a09.png";